module.exports = __webpack_public_path__ + "static/img/002.66a78483.png";